import { Root, createRoot } from "react-dom/client";
import React from "react";
import { assert } from "../../../js/common/assert";
import menuOverlayService, { MenuToggleVisibilityEvent } from "./MenuOverlayService";
import DiscountMenuModal from "./components/DiscountMenuModal";
import { HeaderConfiguration, HeaderDiscountItem } from "./common";
import elementService from "@/common/ElementService";

export default new class EshopDiscountMenuService {
    private modalRoot: Root | undefined;

    private readonly headerDiscounts: HTMLDivElement;
    private readonly headerContainerDiscounts: HTMLDivElement;

    private discountItems: HeaderDiscountItem[] | undefined;

    constructor() {
        this.headerDiscounts = elementService.querySelector<HTMLDivElement>("#header-discounts");
        this.headerContainerDiscounts = elementService.querySelector<HTMLDivElement>("#headerContainerDiscounts");
    }

    public init(headerConfiguration: HeaderConfiguration): void {
        this.discountItems = headerConfiguration.discountItems;
        elementService.elementQuerySelector<HTMLButtonElement>(this.headerDiscounts, "button").addEventListener("click", () => this.toggleMenuVisibility());

        menuOverlayService.addEventListener(MenuToggleVisibilityEvent.Type, (event: Event): void => {
            assert(event instanceof MenuToggleVisibilityEvent);

            if (this.modalRoot === undefined) {
                this.headerDiscounts.classList.toggle("modal-hidden", event.isVisible);
            }
        });
    }

    public toggleMenuVisibility(): void {
        if (this.modalRoot !== undefined) {
            this.hideMenu();
        } else {
            this.showMenu();
        }
    }

    private showMenu(): void {
        if (this.discountItems === undefined) {
            throw new Error("Discount items are not defined.");
        }

        this.modalRoot = createRoot(this.headerContainerDiscounts);

        this.modalRoot.render(
            <DiscountMenuModal
                parentSelector={this.headerContainerDiscounts}
                items={this.discountItems}
                onClose={(): void => this.hideMenu()}
            />,
        );

        this.headerDiscounts.classList.add("active");

        menuOverlayService.showOverlay(() => this.hideMenu());
    }

    private hideMenu(): void {
        this.modalRoot?.unmount();
        this.modalRoot = undefined;
        this.headerDiscounts.classList.remove("active");
        menuOverlayService.hideOverlay();
    }
}();
